// @flow
import React from "react";
import ModalV2 from "@tvg/atomic-ui/_templates/ModalV2";
import { NullaryFn } from "@tvg/ts-types/Functional";
import RunnerNumber from "@fdr/atomic-ui/_atoms/RunnerNumber";
import RichText from "@fdr/atomic-ui/_atoms/RichText";
import type { RaceTypeCodeEnum } from "@tvg/types/Race";
import {
  Card,
  Body,
  RunnerTag,
  RunnerTagDescription,
  CardsList,
  ListTitle
} from "./styled-components";

interface LinkedRunner {
  raceTypeCode: RaceTypeCodeEnum;
  runnerId: string;
  horseName: string;
}

interface RunnerTags {
  id: string;
  name: string;
  description: string;
}

interface Props {
  onClose: NullaryFn<void>;
  isOpen: boolean;
  currentRunnerTags: string[];
  runnerTags: RunnerTags[];
  linkedRunner: LinkedRunner;
}

const CardsListBuilder = (
  linkedRunner: LinkedRunner,
  runnerTags: RunnerTags[],
  isCurrentTags: boolean
) => {
  return (
    <CardsList>
      {
        <ListTitle>
          {isCurrentTags ? (
            <React.Fragment>
              Linked to
              <RunnerNumber
                raceTypeCode={linkedRunner.raceTypeCode}
                runnerId={linkedRunner.runnerId}
              />
              {linkedRunner.horseName}
            </React.Fragment>
          ) : (
            <React.Fragment>Other Tags (A-Z)</React.Fragment>
          )}
        </ListTitle>
      }
      {runnerTags.map((runnerTag) => (
        <Card>
          <RunnerTag>{runnerTag.name}</RunnerTag>
          <RunnerTagDescription>
            <RichText text={runnerTag.description} />
          </RunnerTagDescription>
        </Card>
      ))}
    </CardsList>
  );
};

const RunnerTagsModal = (props: Props) => {
  const pickedCurrentTags = props.runnerTags.filter((runnerTag) =>
    props.currentRunnerTags.includes(runnerTag.id)
  );

  const remainingTags = props.runnerTags.filter(
    (runnerTag) => !props.currentRunnerTags.includes(runnerTag.id)
  );
  return (
    <React.Fragment>
      <ModalV2
        onClose={props.onClose}
        title="Runner Tags"
        isOpen={props.isOpen}
        isFullHeight
        animation="bottom"
      >
        {() => (
          <Body>
            {CardsListBuilder(props.linkedRunner, pickedCurrentTags, true)}
            {CardsListBuilder(props.linkedRunner, remainingTags, false)}
          </Body>
        )}
      </ModalV2>
    </React.Fragment>
  );
};

export default RunnerTagsModal;
